import { render, staticRenderFns } from "./RuleHelp.vue?vue&type=template&id=c80b056a"
import script from "./RuleHelp.vue?vue&type=script&lang=ts"
export * from "./RuleHelp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports